(function() {
    'use strict';
    function MwEmailAddressExpansionPanelController($scope, $element, $translate, $sce) {
        var contentElement = $element.find('md-card-content'),
            findBoxInput = $element.find('.find-box input'),
            expandIcon = $element.find('md-icon.expand-icon'),
            searchIcon = $element.find('md-icon.search-icon'),
            collapseIcon = $element.find('md-icon.collapse-icon');

        this.title = 'icm-search__email-filter--title';
        this.generalInfoTip = 'icm-search__email-filter--general-info-tip';
        this.noResultsInfoTip = 'icm-search__email-filter--no-results-info-tip';
        this.findBoxPlaceholder = 'icm-search__email-filter--input-placeholder';
        this.resultsCount = undefined;
        this.resultsCountMessage = 'icm-search__email-filter--result-count';
        this.loading = false;
        this.loadingMessage = 'icm-search__email-filter--loading-message';
        this.emailAddress = '';

        this.$translate = $translate;
        this.$sce = $sce;

        this.toggle = function toggle() {
            $element.toggleClass('active');
            contentElement.toggle();
            expandIcon.toggle();
            collapseIcon.toggle();

            // $element[0].scrollIntoView();
        };

        this.emailAddressChanged = function emailAddressChanged(e) {
            // user pressed enter. add the email to the filter
            if(e.keyCode === 13 && this.emailAddress.length) {
                if(!this.isSelected({emailAddress: this.emailAddress})) {
                    this.loading = true;
                    this.selectionChanged({selectedItem: this.emailAddress});
                }

                this.emailAddress = '';
            }
        };

        this.clickedClear = function clickedClear(e) {
            e.stopPropagation();

            this.emailAddress = '';

            if(this.clearSelection) {
                this.clearSelection();
            }
        };

        this.onFocus = function onFocus() {
            searchIcon.addClass('active');
        };

        this.onBlur = function onBlur() {
            if (this.emailAddress.length === 0) {
                searchIcon.removeClass('active');
            }
        };

        this.$onChanges = function $onChanges(changes) {
            if(changes.resultCount) {
                this.resultsCount = changes.resultCount.currentValue;
                this.resultsCountMessage = this.getItemCountMessage(changes.resultCount.currentValue);
            }

            // this component gets a search state told to it. based on that we can determine if our filter is in a "loading" state
            if(changes.searchInProgress) {
                this.loading = changes.searchInProgress.currentValue;
            }
        };

        this.getItemCountMessage = function getItemCountMessage(count) {
            let message = ((count > 1 || count === 0) ? 'icm-search__email-filter--results-count' : 'icm-search__email-filter--result-count');
            let countString = ((count >= 500) ? '+500' : count);

            return this.$translate.instant(message, {itemCount: '<b>' + countString + '</b>'}, null, null, null);
        };

        this.clearInput = function clearInput() {
            this.emailAddress = '';
            findBoxInput.focus();
        };
    }

    angular
        .module('MW.ContactManager.MwEmailAddressExpansionPanel', [])
        .component('mwEmailAddressExpansionPanel', {
            bindings: {
                clearSelection: '&',
                selectionChanged: '&',
                isSelected: '&',
                selectionCount: '&',
                resultCount: '<',
                searchInProgress: '<'
            },
            controller: ['$scope', '$element', '$translate', '$sce', MwEmailAddressExpansionPanelController],
            template: `
                <md-card>
                    <md-card-title ng-click="$ctrl.toggle()">
                        <md-card-title-text layout="row">
                            <span flex>
                                <span class="panel-title" translate>{{$ctrl.title}}</span>
                                <mw-infotip class="title-infotip" text-content="{{$ctrl.generalInfoTip}}"></mw-infotip>
                                <span ng-if="$ctrl.selectionCount()" class="panel-title" ng-hide="true">({{$ctrl.selectionCount()}})</span>
                                <span class="clear-selection pull-right" ng-if="$ctrl.selectionCount()" ng-click="$ctrl.clickedClear($event)" translate>icm-search__filter-clear</span>
                            </span>
                            <md-icon class="expand-icon" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>
                            <md-icon class="collapse-icon" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>
                        </md-card-title-text>
                    </md-card-title>
                    <md-card-content ng-class="{'with-border': $ctrl.hideAutocomplete}">
                        <div class="find-box">
                            <md-icon class="search-icon" md-svg-icon="action:ic_search_24px"></md-icon>
                            <input ng-model="$ctrl.emailAddress" ng-keypress="$ctrl.emailAddressChanged($event)"></input>
                            <md-icon ng-show="$ctrl.emailAddress" ng-click="$ctrl.clearInput()" class="clear-icon" md-svg-icon="content:ic_clear_24px"></md-icon>
                        </div>
                        <md-toolbar class="result-count-toolbar" ng-show="($ctrl.selectionCount() > 0 && ($ctrl.resultsCount >= 0 || $ctrl.isLoading))" layout="row" layout-align="start center">
                            <span ng-if="!$ctrl.loading" class="results-count">
                                <span class="item-count-message" ng-bind-html="$ctrl.resultsCountMessage"></span>
                                <mw-infotip class="no-results-infotip" ng-show="$ctrl.resultsCount === 0" text-content="{{$ctrl.noResultsInfoTip}}"></mw-infotip>
                            </span>
                            <span ng-if="$ctrl.loading">
                                <span class="loading-message" translate>{{$ctrl.loadingMessage}}</span>
                            </span>
                        </md-toolbar>
                    </md-card-content>
                </md-card>
            `
        });
}());
